import { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Constants, {
  NavigationScreenName,
  ScreenNameList,
} from "@lib/utilities/Constants";
import Storage from "@lib/utilities/storage/StorageFunctions";
import CheckSession from "@lib/utilities/CheckSession";
import { fetchUserEmail, getEnv } from "@lib/utilities/HelperFunctions";
import { clearSessionAndLogout } from "@lib/utilities/AuthHelper";
import { introspectionAPI } from "@lib";
import { forgotPasswordApi } from "@lib";
import { FORGOT_PASSWORD_ROUTE } from "../../../src/navigation/NavigationConstants";
import Crashlytics from "@lib/utilities/crashlyticsUtils/CrashlyticsUtils";
import { messages } from "../../../src/resources/strings";
import { useAppSelector } from "@lib";

export const useForgotPassword = (navigation: any, route: any) => {
  const [isLoading, setLoading] = useState(false);
  const [errorHandle, setErrorHandle] = useState(messages.error.noError);
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [heading, setHeading] = useState(``);
  const [btnLabel, setBtnLabel] = useState(``);
  const [isModalVisible, setModalVisible] = useState(false);
  const [email, setEmail] = useState(``);
  const { isConnected } = useAppSelector((state) => state.userReducer);
  const { logout } = useAuth0();

  const checkSession = async () => {
    Storage.storeData(
      Constants.LocalStoreConstant.CURRENT_LOADED_SCREEN,
      ScreenNameList.resetPassword,
    );
    const session = await CheckSession();
    if (session) {
      setStateVariables();
    } else {
      handleInvalidTokenCase();
    }
  };

  const setStateVariables = async () => {
    if (route.params.email == ``) {
      setLoading(true);
      const userEmail = await fetchUserEmail();
      if (userEmail) {
        setEmail(userEmail);
      }
      setLoading(false);
    } else {
      setEmail(route.params.email);
    }
    if (!isEmailSent) {
      setHeading("Forgot Password?");
      setBtnLabel("Reset Password");
    }
  };

  const resetPasswordAction = async () => {
    if (isConnected) {
      callIntrospectionAndForgotPasswordApi();
    } else {
      await showInternetalert();
    }
  };

  const callIntrospectionAndForgotPasswordApi = async () => {
    const introspectionResponse = await introspectionAPI();
    if (introspectionResponse.response) {
      callForgotPasswordAPIandUpdateResponse();
    } else if (introspectionResponse.errorCode == messages.error.networkError) {
      setLoading(false);
      showInternetalert();
    } else {
      setErrorHandle(messages.error.resetPasswordLogout);
      setLoading(false);
    }
  };

  const callForgotPasswordAPIandUpdateResponse = async () => {
    setLoading(true);
    const responseObj = await forgotPasswordApi();
    if (responseObj.errorCode == messages.error.noError) {
      setHeading("Check your Inbox");
      setBtnLabel("Home");
      setIsEmailSent(true);
    } else if (responseObj.errorCode == messages.error.callAgainAPI) {
      callForgotPasswordAPIandUpdateResponse();
    }
    setErrorHandle(responseObj.errorCode);
    setLoading(false);
  };

  const homeAction = () => {
    navigation.navigate(NavigationScreenName.choosePolicy);
  };

  const toggleModal = () => {
    setModalVisible(!isModalVisible);
  };

  const showInternetalert = async () => {
    setErrorHandle(messages.error.noError);
    setTimeout(() => {
      setErrorHandle(messages.error.youAreOffline);
    }, 10);
  };

  const handleInvalidTokenCase = () => {
    if (isConnected == null || isConnected) {
      clearSessionAndLogout(navigation, logout);
    } else {
      showInternetalert();
    }
  };

  useEffect(() => {
    Crashlytics.logScreen(FORGOT_PASSWORD_ROUTE);
    checkSession();
  }, []);

  return {
    isLoading,
    errorHandle,
    isEmailSent,
    heading,
    btnLabel,
    isModalVisible,
    email,
    resetPasswordAction,
    homeAction,
    toggleModal,
    showInternetalert,
    handleInvalidTokenCase,
    setErrorHandle,
  };
};
